// ../queries/wishlist.gql (lub wishlist.js)
import { gql } from '@apollo/client';

export const GET_WISHLIST_PRODUCTS = gql`
    query GET_WISHLIST_PRODUCTS($pageSize: Int) {
        getWishlistProducts(pageSize: $pageSize) {
            wishlists {
                id
                items_v2 {
                    items {
                        id
                        product {
                            sku
                            name
                            canonical_url
                            image {
                                url
                            }
                            gallery {
                                medium_image_url
                            }
                            prices {
                                amount
                                currency_symbol
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const ADD_PRODUCT_TO_WISHLIST = gql`
    mutation ADD_PRODUCT_TO_WISHLIST($wishlistId: ID!, $wishlistItems: [WishlistItemInput!]!) {
        addProductsToWishlist(wishlistId: $wishlistId, wishlistItems: $wishlistItems) {
            wishlist {
                id
            }
        }
    }
`;

export const REMOVE_PRODUCT_FROM_WISHLIST = gql`
    mutation REMOVE_PRODUCT_FROM_WISHLIST($wishlistId: ID!, $wishlistItemsIds: [ID!]!) {
        removeProductsFromWishlist(wishlistId: $wishlistId, wishlistItemsIds: $wishlistItemsIds) {
            user_errors {
                code
                message
            }
        }
    }
`;